<template>
  <div id="registerPage" class="container">
    <router-link :to="{ name: 'loginPage' }">
      <img
        class="logo"
        :src="`/images/logo-font-${isDark ? 'white' : 'black'}.svg`"
        alt="Logo yuzu"
      />
    </router-link>
    <h2 v-text="state.steps[state.currentStep].title" />
    <p v-text="state.steps[state.currentStep].subtitle" />
    <Toast
      v-if="state.showResumeRegister"
      text="Vous n'avez pas finalisé votre création de compte, veuillez saisir le nom de votre organisation pour continuer."
      color="yellow"
      icon="bi-info-circle"
      :closable="false"
    />
    <transition mode="out-in" name="fade">
      <Component
        :is="stepsComponents[state.currentStep].component"
        :toCheck="state.currentStep === 0 ? state.toCheck : null"
        :isLoading="state.formIsLoading"
        @resend="stepsComponents[state.currentStep].resend(user.email)"
        @validation="stepsComponents[state.currentStep].validation"
      />
    </transition>
  </div>
</template>

<script setup>
import { reactive, inject } from "vue";
import { useDark } from "@vueuse/core";
import { useUserStore } from "@/stores/user.js";
import { useCompanyStore } from "@/stores/company.js";
import { storeToRefs } from "pinia";
import { useToast } from "vue-toastification";
import { setToken } from "@/composables/token.js";
import { getError } from "@/composables/error.js";
import { removeToken } from "@/composables/token.js";
import Form from "./partials/Form.vue";
import CodeConfirmation from "@/components/global/CodeConfirmation.vue";

const crisp = inject("crisp");

const userStore = useUserStore();

const companyStore = useCompanyStore();

const { user, auth_token } = storeToRefs(userStore);

const isDark = useDark();

const toast = useToast();

const emits = defineEmits(["success"]);

const state = reactive({
  toCheck: "",
  formIsLoading: false,
  currentStep: 0,
  showResumeRegister: false,
  steps: [
    {
      title: "Vos Informations",
      subtitle: "Créer un nouveau compte",
    },
    {
      title: "Vérifiez votre e-mail",
      subtitle:
        "Entrez le code de vérification que nous vous avons envoyé à l'adresse renseignée.",
    },
  ],
});

const stepsComponents = [
  {
    component: Form,
    validation: async () => {
      state.formIsLoading = true;

      if (!user.value.user_id) {
        const resp = await userStore.register();

        if (resp.code) {
          toast.error(getError(resp.key));

          if (resp.code) state.toCheck = resp.key.split("_")[2];

          state.formIsLoading = false;

          return;
        }
      }

      state.showResumeRegister = false;
      state.currentStep++;
      crisp.user.setEmail(user.value.email);
      crisp.user.setNickname(
        `${user.value.first_name} ${user.value.last_name}`
      );
      crisp.session.setData({
        user_id: user.value.user_id,
      });

      state.formIsLoading = false;
    },
  },
  {
    component: CodeConfirmation,
    validation: async (code) => {
      state.formIsLoading = true;
      const resp = await userStore.validateEmail(code);

      if (resp.token) {
        setToken(resp.token, "auth_token", auth_token);

        const companyResp = await companyStore.createCompany({
          name: user.value.company_name,
        });

        if (companyResp.code) {
          toast.error(getError(companyResp.key));
        } else {
          emits("success");
        }
      } else {
        toast.error(
          "Code de confirmation incorrect, veuillez vérifier le code renseigné."
        );
      }

      setTimeout(() => {
        state.formIsLoading = false;
      }, 600);
    },
    resend: async (email) => {
      const resp = await userStore.resendEmailCode(email);

      if (!resp.code) {
        toast.info("Le code vous a été de nouveau envoyé.");
      } else {
        toast.error("Erreur lors de l'envoi du code. Reessayez plus tard");
      }
    },
  },
];

if (auth_token.value && !user.value.user_id) {
  removeToken("auth_token", auth_token);
}

if (user.value.user_id && !auth_token.value.email_verified) {
  state.showResumeRegister = true;
  user.value = {
    ...user.value,
    password: "Password1998@",
    confirm_password: "Password1998@",
  };
}
</script>
